import { isMobile, isTablet } from 'react-device-detect';
import { isConfigFlagEnabled } from '../config';
const IS_COLUMN_MODE_AVAILABILITY_FORCED = getIsColumnLayoutModeAvailabilityForced();
/**
 * Allows enabling the feature even if on desktop or if the config flags are disabled, to allow testing portrait
 * mode in Cypress tests.
 */
function getIsColumnLayoutModeAvailabilityForced() {
    const params = new URLSearchParams(window.location.search);
    return params.has('forceColumnLayoutModeAvailable');
}
export function isMobileDeviceForLayoutMode() {
    return isMobile && !isTablet;
}
export function isColumnLayoutModeAvailable() {
    if (IS_COLUMN_MODE_AVAILABILITY_FORCED) {
        return true;
    }
    if (!isConfigFlagEnabled('columnLayoutMode')) {
        return false;
    }
    return isMobileDeviceForLayoutMode() || isConfigFlagEnabled('allowColumnLayoutModeOnDesktop');
}
export function getIsColumnLayoutMode(panelPositionSetting) {
    if (!isColumnLayoutModeAvailable()) {
        return false;
    }
    switch (panelPositionSetting) {
        case 'auto': {
            if (isMobileDeviceForLayoutMode()) {
                return window.innerWidth < window.innerHeight;
            }
            else {
                // use a different aspect ratio threshold on desktop
                return window.innerWidth / window.innerHeight <= 4 / 5;
            }
        }
        case 'right': {
            return false;
        }
        case 'top': {
            return true;
        }
    }
}
